module.exports = __webpack_public_path__ + "img/Flag_of_Tonga.a88b30cd.svg";